module.exports = __webpack_public_path__ + "static/media/bg-image-34.0f82cb28.jpg";